'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');let

FaviconDirective=class FaviconDirective{
static get type(){
return'directive';
}

factory($rootScope,elementService,userService,$window,fatigueMeterTypeContentProviderService){
const _updateFavicon=()=>{
const{faviconUrl,appleTouchIconUrl,webManifestUrl}=fatigueMeterTypeContentProviderService;

fastdom.mutate(()=>{
elementService.setAttributeIfNew('link[rel="icon"]','href',faviconUrl);
elementService.setAttributeIfNew('link[rel="shortcut icon"]','href',faviconUrl);
elementService.setAttributeIfNew('meta[name="msapplication-TileImage"]','content',faviconUrl);
elementService.setAttributeIfNew('link[rel="apple-touch-icon"]','href',appleTouchIconUrl);
elementService.setAttributeIfNew('link[rel="manifest"]','href',webManifestUrl);
});
};

angular.element($window).on('load',()=>_updateFavicon());

return{
restrict:'A',
link:()=>{
$rootScope.$on('$stateChangeSuccess',()=>_updateFavicon());
}};

}};

module.exports=FaviconDirective;
module.exports.prototype.factory.$inject=['$rootScope','elementService','userService','$window','fatigueMeterTypeContentProviderService'];
//# sourceMappingURL=faviconDirective.js.map
